import React from 'react';
import { OtpCard } from 'entities/sendOTP/ui/OTPCard';
import { useCreateOtpDefaultValues } from 'entities/sendOTP/lib';
import { Resolver, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchema } from 'entities/sendOTP/model';
import { OTPFormType } from 'entities/sendOTP/types';
import { useCreateOTPMutation } from 'entities/sendOTP/api';
import { useDispatch } from 'react-redux';
import { setDrawerOpen } from 'features/ui/model/uiSlice';

export const CreateOtpCard = () => {
  const dispatch = useDispatch();
  const [createOTP] = useCreateOTPMutation();
  const defaultValues = useCreateOtpDefaultValues();

  const createOTPForm = useForm<OTPFormType>({
    mode: 'all',
    resolver: yupResolver(validationSchema) as Resolver<OTPFormType>,
    defaultValues,
  });

  const onSubmit: SubmitHandler<OTPFormType> = (dataForm) => {
    createOTP({ data: dataForm }).then(() => {
      dispatch(setDrawerOpen(false));
    });
  };

  return (
    <OtpCard
      form={createOTPForm}
      onSubmit={onSubmit}
      textButton="Добавить"
    />
  );
};
